import { useEffect, useContext } from 'react';
import { useLocation } from 'react-router';
import { useSelector } from 'react-redux';

import URLSearchParamsEx from '#utils/url-ex';
import { FeedbackUIContext } from '#context/feedback-ui-context';
import { useGetCollectionMutation } from '#services/collection';

export interface CollectionFormState {
  id: number | null;
  name: string;
  inactivated: boolean;
  description: string;
  availableForAll: boolean;
  availableForAllReadonly: boolean;
  relatedProducts: unknown[];
  [key: string]: unknown;
}

export const getInitialState = (plainData?: unknown): CollectionFormState => {
  const initialState: CollectionFormState = {
    id: null,
    name: '',
    inactivated: false,
    description: '',
    availableForAll: false,
    availableForAllReadonly: false,

    relatedProducts: [],
  };

  // workaround for redux toolkit
  // TODO use redux to handle the state
  let state = plainData
    ? JSON.parse(JSON.stringify(plainData))
    : initialState;
  state = Object.assign({}, initialState, state);

  return state;
};

export function useData({
  resetForm,
}: {
  resetForm: (state: CollectionFormState) => void;
}) {
  const location = useLocation();

  const urlParams = new URLSearchParamsEx(location as unknown as Record<string, unknown>);
  const {
    collectionIndex,
    collectionId,
    dateRange,
  } = urlParams.values;
  const filter = useSelector((state: { collectionList: { filter: string } }) => state.collectionList.filter);
  const order = useSelector((state: { collectionList: { order: string } }) => state.collectionList.order);
  const orderBy = useSelector((state: { collectionList: { orderBy: string } }) => state.collectionList.orderBy);

  const {
    showBackdrop,
    hideBackdrop,
  } = useContext(FeedbackUIContext)!;

  const [getCollection] = useGetCollectionMutation();

  useEffect(() => {
    showBackdrop();
    void getCollection({
      filter,
      order,
      orderBy,
      collectionId,
      collectionIndex,
      dateRange,
    })
      .then((res) => {
        hideBackdrop();
        resetForm(getInitialState(res.data));
      });
  }, [location.key]);
}
